const CLIENT_FILTER = "CLIENT_FILTER";
const ADMIN_FILTER = "ADMIN_FILTER";
const LM_INVENTORY = "LM_INVENTORY";
const DAILY_DELIVERY_REPORT_FILTER = "DAILY_DELIVERY_REPORT_FILTER";
const ASSIGNED_TO_AIDUK_LM = "ASSIGNED_TO_AIDUK_LM";
const DELIVERED_FILTER = "DELIVERED_FILTER";
const SHIPMENTS_FILTER = "SHIPMENTS_FILTER";
const DELIVERY_RUN_SHEET_FILTER = "DELIVERY_RUN_SHEET_FILTER";
const CLIENT_PICKUP_REQUEST_FILTER = "CLIENT_PICKUP_REQUEST_FILTER";
const CLIENT_PICKUP_REQUEST_ADMIN_FILTER = "CLIENT_PICKUP_REQUEST_ADMIN_FILTER";

module.exports = {
    CLIENT_FILTER,
    ADMIN_FILTER,
    LM_INVENTORY,
    DAILY_DELIVERY_REPORT_FILTER,
    ASSIGNED_TO_AIDUK_LM,
    DELIVERED_FILTER,
    SHIPMENTS_FILTER,
    DELIVERY_RUN_SHEET_FILTER,
    CLIENT_PICKUP_REQUEST_FILTER,
    CLIENT_PICKUP_REQUEST_ADMIN_FILTER
};
